import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    DtgListType
} from "src/app/shared/vo";

@Component({
  templateUrl: "./dtg.manage.driver.search.component.html"
  ,styleUrls: ["./dtg.manage.driver.search.component.scss"]
})
export class DtgManageDriverSearchComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    listItem:any[];
    DtgListType = DtgListType;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
    ) {
        
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    callbackSelectUser(userInfo:any){
        this.clickSelectUser(userInfo);
    }

    clickSelectUser(userInfo:any){
        this.activeModal.close({
            "result":"ok"
            ,"userInfo":userInfo
        });
    }
}
